import API from "./api";

const today = new Date();
// ! Category

export const fetchCategory = () =>
  API.get("/api/v1/company-category?asset_pool[ne]=INTANGIBLES");

export const CompanyCategory = (postData) =>
  API.post("/api/v1/company-category", postData);

// ! Location

export const fetchLocations = () => API.get("/api/v1/company-location");

export const CompanyLocation = (postData) =>
  API.post("/api/v1/company-location", postData);

// ! Assets

export const fetchAssets = () =>
  API.get(
    "/api/v1/company-assets/get-asset-by-code/code?disposed[ne]=true&approved=true"
  );
export const fetchIntangibleAssets = () =>
  API.get(
    "/api/v1/company-assets/get-asset-by-code/code?disposed=false&approved=true&category[eq]=intangibles"
  );
// "/api/v1/company-assets/get-asset-by-code/code?disposed=true"
export const createAsset = (postData) =>
  API.post("/api/v1/company-assets", postData);
// ! Asset Revaluation

export const revaluateAsset = (postData, id) =>
  API.patch(`/api/v1/company-assets/update-asset/${id}`, postData);
export const updateAsset = (id, postData) =>
  API.patch(`/api/v1/company-assets/update-asset/${id}`, postData);

export const getRevaluedAsset = () =>
  API.get(
    "/api/v1/company-assets/ppe/ppe-section?revalued=true&disposed=false"
  );
// !Get new created and unapproved assets
export const getNewAssets = () =>
  API.get("/api/v1/company-assets/ppe/ppe-section?approved=false");
// ! Asset Disposal
export const deleteNewAsset = (id) =>
  API.delete(`/api/v1/company-assets/delete-asset/${id}`);
export const getDisposedAsset = () =>
  API.get("/api/v1/company-assets/ppe/ppe-section?disposed=true");
export const disposeAsset = (postData, id) =>
  API.patch(`/api/v1/company-assets/update-asset/${id}`, postData);
// sign in a new user
export const signIn = (formData) => API.post("/api/v1/users/login", formData);
// Sign up a new user
export const signup = (formData) => API.post("/api/v1/users/signup", formData);

// Security
// forgot password
export const forgotPassword = (postData) =>
  API.post("/api/v1/users/forgotPassword", postData);

// reset password
export const resetPassword = (token, postData) =>
  API.patch(`/api/v1/users/resetPassword/${token}`, postData);

// reset password
export const changePassword = (postData) =>
  API.patch(`/api/v1/users/updateMypassword`, postData);

export const getUsers = () => API.get("/api/v1/users");

export const getRightOfUseAsset = () =>
  API.get(
    "/api/v1/company-assets/get-asset-by-code/code?category=right-of-use asset&approved[ne]=false&disposed[eq]=false"
  );

// ! Update users information and delete users
export const updateUser = (id, postData) =>
  API.patch(`/api/v1/users/update-user/info/${id}`, postData);
export const deleteUser = (id) =>
  API.delete(`/api/v1/users/delete-selected-user/info/${id}`);

export const exhaustedAsset = () =>
  API.get(
    `/api/v1/company-assets/ppe/ppe-section?category[ne]=right-of-use asset&disposed[ne]=true&approved=true&exhaustion_date[lt]=${today}`
  );
export const activeAsset = () =>
  API.get(
    `/api/v1/company-assets/ppe/ppe-section?disposed[eq]=false&approved=true&exhaustion_date[gte]=${today}`
  );

export const disposedAsset = () =>
  API.get(`/api/v1/company-assets/ppe/ppe-section?approved=true&disposed=true`);

export const locationData = () =>
  API.get("/api/v1/company-assets/get-all-locations-number-of-assets");
export const yearData = () =>
  API.get("/api/v1/company-assets/get-all-years-value-of-assets");
